module.exports = __webpack_public_path__ + "img/cup-and-ball.5f46e949.png";